/** @jsxImportSource @emotion/react */

import { Copy, Typography } from '@quickbit/qb-design-system';

interface Props {
  text: string;
  type?: 'middle' | 'end';
  split?: number;
}

export const TruncatedString = ({
  text,
  type = 'middle',
  split = 4,
}: Props) => {
  const truncated =
    type === 'middle'
      ? `${text.slice(0, split)}...${text.slice(
          text.length - split,
          text.length
        )}`
      : `${text.slice(0, split)}${text.length > split ? '...' : ''}`;
  return (
    <div css={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="bodySmall">{truncated}</Typography>
      <div onClick={(e) => e.stopPropagation()}>
        <Copy textToCopy={text} />
      </div>
    </div>
  );
};
